import i18next from 'i18next';

i18next.addResources('es', 'infraestructureSelector', {
  infraestructureTypes: 'Infraestructura',
  energy: 'Energía',
  boundary: 'Fronteras',
  transport: 'Transporte y logística',
  telecommunications: 'Telecomunicaciones'
});

i18next.addResources('en', 'infraestructureSelector', {
  infraestructureTypes: 'Infrastructure',
  energy: 'Energy',
  boundary: 'Borders',
  transport: 'Transport and Logistics',
  telecommunications: 'Telecommunications'
});

i18next.addResources('pt', 'infraestructureSelector', {
  infraestructureTypes: 'Infraestrutura',
  energy: 'Energia',
  boundary: 'Fronteiras',
  transport: 'Transporte e Logística',
  telecommunications: 'Telecomunicações'
});
